import { render, staticRenderFns } from "./ObjectsList.vue?vue&type=template&id=23555a90&"
import script from "./ObjectsList.vue?vue&type=script&lang=js&"
export * from "./ObjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports